import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { clone } from '@jd/jmtd-tools/es/object';
import TimePanel from '../TimePanel';
import Placeholder from '../Placeholder';
import { getLocale } from '../locale';
export function getTimeShow(value) {
  // 没有value，返回空
  if (!value) {
    return '';
  }

  var timePlaceholder = [getLocale(this.locale).datePicker.startTime, getLocale(this.locale).datePicker.endTime]; // 只有起始或结束

  if (!value[0] || !value[1]) {
    value = [0, 1].map(function (i) {
      var _value$i;

      return (_value$i = value[i]) !== null && _value$i !== void 0 ? _value$i : /*#__PURE__*/React.createElement(Placeholder, null, timePlaceholder[i]);
    });
  } else if (value[0].split(':').join('') - value[1].split(':').join('') > 0) {
    // 如果起始时间大于结束，倒转显示
    value = [value[1], value[0]];
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, value[0], " ~ ", value[1]);
}
var RangeTimePanel = {
  timePanel: true,
  type: 'rangeTime',
  label: '双面板时间',
  echo: getTimeShow,
  render: function render(_ref) {
    var _value;

    var value = _ref.value,
        _update = _ref.update,
        _ref$config = _ref.config,
        startConfig = _ref$config.startConfig,
        endConfig = _ref$config.endConfig,
        _ref$config$isItemDis = _ref$config.isItemDisabled,
        isItemDisabled = _ref$config$isItemDis === void 0 ? function () {
      return false;
    } : _ref$config$isItemDis,
        locale = _ref.locale;
    value = clone((_value = value) !== null && _value !== void 0 ? _value : []);

    var _TimePanel$render = TimePanel.render({
      title: getLocale(locale).datePicker.startTime,
      value: value[0],
      update: function update(newTime) {
        if (newTime) value[0] = newTime;

        _update(value);
      },
      config: _objectSpread(_objectSpread({}, startConfig), {}, {
        isValueDisabled: function isValueDisabled(v) {
          var _ref2 = startConfig || {},
              _ref2$isValueDisabled = _ref2.isValueDisabled,
              isValueDisabled = _ref2$isValueDisabled === void 0 ? function () {
            return false;
          } : _ref2$isValueDisabled;

          return isValueDisabled(v) || isItemDisabled(v, value[1]);
        }
      })
    }),
        startTimePanelDropdown = _TimePanel$render.dropdown;

    var _TimePanel$render2 = TimePanel.render({
      title: getLocale(locale).datePicker.endTime,
      value: value[1],
      update: function update(newTime) {
        if (newTime) value[1] = newTime;

        _update(value);
      },
      config: _objectSpread(_objectSpread({}, endConfig), {}, {
        isValueDisabled: function isValueDisabled(v) {
          var _ref3 = endConfig || {},
              _ref3$isValueDisabled = _ref3.isValueDisabled,
              isValueDisabled = _ref3$isValueDisabled === void 0 ? function () {
            return false;
          } : _ref3$isValueDisabled;

          return isValueDisabled(v) || isItemDisabled(value[0], v);
        }
      })
    }),
        endTimePanelDropdown = _TimePanel$render2.dropdown;

    return {
      defaultValue: [],
      // 历史原因兼容模式，用于disabledClose
      notCloseWhenUpdate: true,
      dropdown: /*#__PURE__*/React.createElement(React.Fragment, null, startTimePanelDropdown, endTimePanelDropdown)
    };
  }
};
export default RangeTimePanel;